import { inject, Injectable, InjectionToken } from '@angular/core';
import { LOGGER } from '../../shared/logging/log.service';
import { PaginatedResponse } from '../../shared/pagination/paginated-response';
import { ApiIntegrationService } from '../api-types/service.api';
import { IntegrationService } from '../app-types/service.app';
import { transformApiIntegrationServicesToAppIntegrationServices } from '../transformers/service.transform';
import { BaseRequestService } from './base-request.service';

export const INTEGRATION_SERVICE_SERVICE = new InjectionToken<IntegrationServiceService>('IntegrationServiceService');

@Injectable()
export class IntegrationServiceService extends BaseRequestService {
	private readonly log = inject(LOGGER);
	public async getServicesByIfd(
		ifdId?: unknown,
		offset?: number,
		range?: number,
	): Promise<PaginatedResponse<IntegrationService>> {
		if (!ifdId) {
			this.log.log('IFD ID is not provided');
			return {
				offset: 0,
				range: 0,
				totalEntities: 0,
				entities: [],
			};
		}
		const params = offset === undefined && range === undefined ? undefined : { offset, range };
		const response = params
			? await this.get<PaginatedResponse<ApiIntegrationService>>(`services/${ifdId}`, params)
			: await this.get<PaginatedResponse<ApiIntegrationService>>(`services/${ifdId}`);
		const services = transformApiIntegrationServicesToAppIntegrationServices(response.entities);
		return {
			...response,
			entities: services,
		};
	}
}
